Shopify.theme.jsAccessoriesCustom = {
  init: function ($section) {
    // Add settings from schema to current object
    Shopify.theme.jsAccessoriesCustom = $.extend(this, Shopify.theme.getSectionData($section));
    
    const $accessoriesSlider = $section.find('[data-slider]');
    
    if ($accessoriesSlider.length === 0) {
      console.warn('Accessories Custom: No slider container found');
      return;
    }
    
    console.log('Accessories Custom: Initializing (like testimonials)');
    
    // Default settings (like testimonials but start from first item)
    const flickityOptions = {
      wrapAround: false,
      initialIndex: 0,
      prevNextButtons: false,
      pageDots: true,
      watchCSS: true,
      cellAlign: 'center',
      contain: true,
      percentPosition: false,
      selectedAttraction: 0.2,
      friction: 0.8
    };
    
    // Check window width and adjust options (exactly like testimonials)
    function setupSlider() {
      if (window.innerWidth <= 798) {
        // Mobile settings - no grouping with edge case fixes
        $accessoriesSlider.flickity($.extend({}, flickityOptions, {
          groupCells: false,
          contain: false,
          wrapAround: false,
          freeScroll: false
        }));
      } else {
        // Desktop settings - group 3 cells (back to safe settings)
        $accessoriesSlider.flickity($.extend({}, flickityOptions, {
          groupCells: 3
        }));
      }
    }
    
    // Initialize on load (like testimonials)
    setupSlider();
    
    // Re-initialize on resize with better debouncing
    let resizeTimer;
    $(window).on('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function() {
        if ($accessoriesSlider.data('flickity')) {
          $accessoriesSlider.flickity('destroy');
        }
        setupSlider();
      }, 250);
    });

    // Resize flickity when the slider is settled
    $accessoriesSlider.on('settle.flickity', function () {
      $accessoriesSlider.flickity('resize');
    });

    $section.on('click', '.accessories-custom__nav--prev', function () {
      $accessoriesSlider.flickity('previous');
    });

    $section.on('click', '.accessories-custom__nav--next', function () {
      $accessoriesSlider.flickity('next');
    });
  },

  blockSelect: function($section, blockId) {
    const $accessoriesSlider = $section.find('[data-slider]');
    const $block = $('#shopify-section-' + blockId);
    const slideIndex = $block.data('index');

    if ($accessoriesSlider.length && typeof slideIndex !== 'undefined') {
      $accessoriesSlider.flickity('select', slideIndex, true, true);
    }
  },

  unload: function($section) {
    // Destroy flickity
    const $accessoriesSlider = $section.find('.flickity-enabled');
    if ($accessoriesSlider.length) {
      $accessoriesSlider.flickity('destroy');
    }

    // Remove event listeners
    $(window).off('resize');
    $section.off('click', '.accessories-custom__nav--prev');
    $section.off('click', '.accessories-custom__nav--next');
  }
} 